import React from "react";
import PropTypes from "prop-types";
import { Checkbox } from "@chakra-ui/react";
import Select from "~components/Form/components/Select";
import Multiselect from "multiselect-react-dropdown";

const ReplicationSection = ({
  negociacaoId,
  values,
  // Condição Especial props
  centroCEDisabled,
  handleChangeTipoReplicacao,
  onChangeFilialReplicacaoMulti,
  optionFiliaisReplicacaoFiltered,
  formikRef,
  // Faixa props
  grupoProdutoDisabled,
  familiaProdutoDisabled,
  produtosDisabled,
  grupoCentralizadorDisabled,
  onChangeGrupoProdutoReplicacao,
  optionGruposProdutoReplicacao,
  grupoProdutoReplicacaoSelect,
  onChangeSubGrupoMaterial,
  optionSubGrupoMateriais,
  subGrupoMaterialSelect,
  onChangeProdutoReplicacao,
  optionProdutosReplicacao,
  onChangeProdutoReplicacaoMulti,
  onChangeGrupoCentralizadorReplicacao,
  optionGruposCentralizadoresReplicacao,
  grupoCentralizadorReplicacaoSelect,
}) => {
  if (negociacaoId) {
    return null;
  }

  return (
    <>
      {values.tipoProposta == "condicaoEspecial" ? (
        <div className="card">
          <h2 className="title">Replicar Negociação</h2>

          <div className="replicate-inputs grid grid-cols-2">
            <label className="label">
              <Checkbox
                checked={centroCEDisabled}
                className="input"
                onChange={() => {
                  handleChangeTipoReplicacao("centroCEDisabled");
                  onChangeFilialReplicacaoMulti([]);
                }}
              />
              <span className="desc">Centro</span>
            </label>
            <Multiselect
              name="filialReplicacaoId"
              options={optionFiliaisReplicacaoFiltered}
              selectedValues={formikRef.current?.values?.centros}
              placeholder=""
              showArrow
              customArrow={true}
              displayValue="label"
              disable={centroCEDisabled}
              emptyRecordMsg="Nenhum centro não encontrado"
              onRemove={onChangeFilialReplicacaoMulti}
              onSelect={onChangeFilialReplicacaoMulti}
              data-test-id="select-replicacao-filial"
            />
          </div>
        </div>
      ) : (
        <div className="card">
          <h2 className="title">Replicar Negociação</h2>

          <div className="replicate-inputs grid grid-cols-2">
            <label className="label">
              <Checkbox
                isChecked={!grupoProdutoDisabled}
                className="input"
                disabled={!familiaProdutoDisabled || !produtosDisabled}
                onChange={() => {
                  handleChangeTipoReplicacao("grupoProdutoDisabled");
                  onChangeGrupoProdutoReplicacao("");
                }}
                data-test-id="checkbox-replicacao-grupo-produtos"
              />
              <span className="desc">Grupo de Produtos</span>
            </label>

            <Select
              name="grupoProdutoReplicacaoId"
              label=""
              placeholder=""
              options={optionGruposProdutoReplicacao}
              noOptionsMessage="Grupo não encontrado"
              onChange={(e) => onChangeGrupoProdutoReplicacao(e)}
              {...grupoProdutoReplicacaoSelect}
              isDisabled={grupoProdutoDisabled}
              data-test-id="select-replicacao-grupo-produtos"
            />

            <label className="label">
              <Checkbox
                isChecked={!familiaProdutoDisabled}
                className="input"
                disabled={!grupoProdutoDisabled || !produtosDisabled}
                onChange={() => {
                  handleChangeTipoReplicacao("familiaProdutoDisabled");
                  onChangeSubGrupoMaterial("");
                }}
                data-test-id="checkbox-replicacao-subgrupo-produtos"
              />
              <span className="desc">SubGrupo de Produto</span>
            </label>

            <Select
              options={optionSubGrupoMateriais}
              name="subGrupoMaterialReplicacaoId"
              label=""
              placeholder=""
              noOptionsMessage="Tipo de Produto não encontrado"
              onChange={(e) => onChangeSubGrupoMaterial(e)}
              isDisabled={familiaProdutoDisabled}
              {...subGrupoMaterialSelect}
              data-test-id="select-replicacao-subgrupo-produtos"
            />

            <label className="label">
              <Checkbox
                isChecked={!produtosDisabled}
                className="input"
                disabled={!grupoProdutoDisabled || !familiaProdutoDisabled}
                onChange={() => {
                  handleChangeTipoReplicacao("produtosDisabled");
                  onChangeProdutoReplicacao("");
                }}
                data-test-id="checkbox-replicacao-produto"
              />
              <span className="desc">Produto</span>
            </label>

            <div data-test-id="select-replicacao-produto">
              <Multiselect
                name="produtoReplicacaoId"
                options={optionProdutosReplicacao}
                selectedValues={formikRef.current?.values?.produtos}
                placeholder=""
                showArrow
                customArrow={true}
                displayValue="label"
                disable={produtosDisabled}
                emptyRecordMsg="Produto não encontrado"
                onRemove={onChangeProdutoReplicacaoMulti}
                onSelect={onChangeProdutoReplicacaoMulti}
              />
            </div>

            <label className="label">
              <Checkbox
                isChecked={!grupoCentralizadorDisabled}
                className="input"
                onChange={() => {
                  handleChangeTipoReplicacao("grupoCentralizadorDisabled");
                  onChangeGrupoCentralizadorReplicacao("");
                }}
                data-test-id="checkbox-replicacao-grupo-centralizador"
              />
              <span className="desc">Grupo Centralizador</span>
            </label>

            <Select
              name="grupoCentralizadorReplicacaoId"
              label=""
              placeholder=""
              options={optionGruposCentralizadoresReplicacao}
              noOptionsMessage="Grupo não encontrado"
              onChange={(e) => onChangeGrupoCentralizadorReplicacao(e)}
              {...grupoCentralizadorReplicacaoSelect}
              isDisabled={grupoCentralizadorDisabled}
              data-test-id="select-replicacao-grupo-centralizador"
            />
          </div>
        </div>
      )}
    </>
  );
};

ReplicationSection.propTypes = {
  negociacaoId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  values: PropTypes.object.isRequired,
  centroCEDisabled: PropTypes.bool.isRequired,
  handleChangeTipoReplicacao: PropTypes.func.isRequired,
  onChangeFilialReplicacaoMulti: PropTypes.func.isRequired,
  optionFiliaisReplicacaoFiltered: PropTypes.arrayOf(PropTypes.object),
  formikRef: PropTypes.object.isRequired,
  grupoProdutoDisabled: PropTypes.bool.isRequired,
  familiaProdutoDisabled: PropTypes.bool.isRequired,
  produtosDisabled: PropTypes.bool.isRequired,
  grupoCentralizadorDisabled: PropTypes.bool.isRequired,
  onChangeGrupoProdutoReplicacao: PropTypes.func.isRequired,
  optionGruposProdutoReplicacao: PropTypes.arrayOf(PropTypes.object),
  grupoProdutoReplicacaoSelect: PropTypes.object,
  onChangeSubGrupoMaterial: PropTypes.func.isRequired,
  optionSubGrupoMateriais: PropTypes.arrayOf(PropTypes.object),
  subGrupoMaterialSelect: PropTypes.object,
  onChangeProdutoReplicacao: PropTypes.func.isRequired,
  optionProdutosReplicacao: PropTypes.arrayOf(PropTypes.object),
  onChangeProdutoReplicacaoMulti: PropTypes.func.isRequired,
  onChangeGrupoCentralizadorReplicacao: PropTypes.func.isRequired,
  optionGruposCentralizadoresReplicacao: PropTypes.arrayOf(PropTypes.object),
  grupoCentralizadorReplicacaoSelect: PropTypes.object,
};

export default ReplicationSection;
